module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo06-nikon_thumb-f6e9fd194c35b56033ad8c286fd72b97.jpg";